import { type ConfirmStorageKey, type OnboardingStorageKey, persistentStorage } from '../../../lib/storage';
import { changeOnboardingStage, changeOnboardingSubtask, invalidateOnboardingCache } from '../api/api';
import { getOnboardingConfig } from '../api/onboardingVariant';

export const resetOnboarding = async (): Promise<void> => {
    const { publishStageSlug, stageSlugs, subtaskSlugs } = getOnboardingConfig();

    await changeOnboardingStage({
        slug: publishStageSlug,
        value: false,
    });
    await Promise.all(
        subtaskSlugs.map(async (slug) => {
            await changeOnboardingSubtask({
                slug,
                value: false,
            });
        })
    );
    await Promise.all(
        stageSlugs
            .filter((slug) => slug !== publishStageSlug)
            .map(async (slug) => {
                await changeOnboardingStage({
                    slug,
                    value: false,
                });
            })
    );

    const keys: (ConfirmStorageKey | OnboardingStorageKey)[] = [
        'onboarding.hasSeenWelcomeModal',
        'onboarding.constructor.modal',
        'onboarding.hasClickedOnPublish',
        'onboarding.finished',
    ];

    keys.forEach((key) => {
        persistentStorage.removeItem(key);
    });

    invalidateOnboardingCache();
};
